export default __webpack_public_path__ + "static/media/suburbia.7bfc8690.svg";